"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, forwardRef, useMultiStyleConfig } from "@chakra-ui/react";
import { BackgroundColorTheme } from "./Background.types";
const Background = forwardRef(({ children, variant, width = "100%", height = "100%", backgroundColor = "semantic.foreground.primary", colorTheme = BackgroundColorTheme.GREEN, reverse = true, }, ref) => {
    const styles = useMultiStyleConfig("Background", {
        variant,
        width,
        height,
        backgroundColor,
        colorTheme,
        reverse,
    });
    return (_jsxs(Box, Object.assign({ ref: ref, sx: styles.container }, { children: [_jsxs(Box, Object.assign({ sx: styles.back }, { children: [_jsxs(Box, Object.assign({ sx: styles.columnOne }, { children: [_jsx(Box, { sx: styles.rowOne }), _jsx(Box, { sx: styles.rowTwo })] })), _jsx(Box, { sx: styles.columnTwo })] })), _jsx(Box, Object.assign({ sx: styles.front }, { children: children }))] })));
});
Background.displayName = "Background";
export default Background;
//# sourceMappingURL=Background.js.map